// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"096d9edb","82":"178b9c80","243":"0694a2a0","562":"3e434139","598":"08220d44","671":"3f1e5736","890":"be330b76","905":"52375546"}[chunkId] + ".chunk.css";
};